import { render, staticRenderFns } from "./CursoCapacitacion.vue?vue&type=template&id=1b04e4e1&"
import script from "./CursoCapacitacion.vue?vue&type=script&lang=js&"
export * from "./CursoCapacitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports